import { render, staticRenderFns } from "./GroupBankcardList.vue?vue&type=template&id=68882215"
import script from "./GroupBankcardList.vue?vue&type=script&lang=js"
export * from "./GroupBankcardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports